(function () {
    /* ── Helpers ── */
    const formatMoney = cents =>
        'CHF ' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    const drawer = document.getElementById('cart-drawer');
    const overlay = document.getElementById('cart-drawer-overlay');
    const closeBtn = document.getElementById('cart-drawer-close');
    const itemsEl = document.getElementById('cart-drawer-items');
    const footerEl = document.getElementById('cart-drawer-footer');
    const totalEl = document.getElementById('cart-drawer-total');
    const loading = document.getElementById('cart-drawer-loading');

    /* ── Open / Close ── */
    function openDrawer() {
        drawer.classList.add('open');
        overlay.classList.add('active');
        document.body.style.overflow = 'hidden';
        renderCart();
    }
    function closeDrawer() {
        drawer.classList.remove('open');
        overlay.classList.remove('active');
        document.body.style.overflow = '';
    }

    overlay.addEventListener('click', closeDrawer);
    closeBtn.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

    /* ── Trigger: click on .cart link ── */
    document.addEventListener('click', function (e) {
        const cartLink = e.target.closest('.cart a');
        if (cartLink) {
            e.preventDefault();
            openDrawer();
        }
    });

    /* ── Fetch & Render Cart ── */
    async function renderCart() {
        loading.classList.add('active');
        try {
            const res = await fetch('/cart.js');
            const cart = await res.json();
            renderItems(cart);
        } catch (err) {
            itemsEl.innerHTML = '<p class="cart-drawer__empty fs-base text-center text-gray">Warenkorb konnte nicht geladen werden.</p>';
        } finally {
            loading.classList.remove('active');
        }
    }

    function renderItems(cart) {
        /* Filter out upsell products */
        const items = cart.items.filter(
            item => (item.product_type || '').toLowerCase() !== 'upsell'
        );

        if (!items.length) {
            itemsEl.innerHTML = '<p class="cart-drawer__empty fs-base text-center text-gray">Ihr Warenkorb ist leer.</p>';
            footerEl.style.display = 'none';
            return;
        }

        footerEl.style.display = 'block';
        totalEl.textContent = formatMoney(
            items.reduce((s, i) => s + i.line_price, 0)
        );

        itemsEl.innerHTML = items.map(item => {
            const imgSrc = item.image
                ? item.image.replace(/(\.[^.]+)$/, '_160x160$1')
                : 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80"/>';

            const comparePrice = item.original_line_price > item.line_price
                ? `<span class="cart-drawer__item-compare fs-sm text-gray-light fw-regular">${formatMoney(item.original_line_price)}</span>`
                : '';

            return `
          <div class="cart-drawer__item flex gap-sm bg-white rounded-md" data-key="${item.key}">
            <img class="cart-drawer__item-img shrink-0 bg-primary object-contain rounded-md" src="${imgSrc}" alt="${item.product_title}" loading="lazy">
            <div class="cart-drawer__item-info">
              <div class="cart-drawer__item-title fs-sm fw-semibold text-gray">${item.product_title}</div>
              ${item.variant_title ? `<div class="cart-drawer__item-variant fs-sm text-gray fw-regular">${item.variant_title}</div>` : ''}
              <div class="cart-drawer__item-price-row flex item-center gap-xs">
                <span class="cart-drawer__item-price fs-base fw-bold text-gray">${formatMoney(item.line_price)}</span>
                ${comparePrice}
              </div>
              <div class="cart-drawer__qty-controls flex item-center gap-xs w-fit bg-primary">
                <button class="cart-drawer__qty-btn pointer flex item-center justify-center rounded-full fs-lg text-gray" data-action="decrease" data-key="${item.key}" aria-label="Decrease quantity">−</button>
                <span class="cart-drawer__qty-num fs-sm fw-semibold text-center">${item.quantity}</span>
                <button class="cart-drawer__qty-btn pointer flex item-center justify-center rounded-full fs-lg text-gray" data-action="increase" data-key="${item.key}" aria-label="Increase quantity">+</button>
              </div>
            </div>
            <button class="cart-drawer__item-remove pointer text-gray rounded-sm shrink-0" data-key="${item.key}" aria-label="Remove item">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
              </svg>
            </button>
          </div>`;
        }).join('');
    }

    /* ── Qty & Remove events ── */
    itemsEl.addEventListener('click', async function (e) {
        const qtyBtn = e.target.closest('.cart-drawer__qty-btn');
        const removeBtn = e.target.closest('.cart-drawer__item-remove');

        if (qtyBtn) {
            const key = qtyBtn.dataset.key;
            const action = qtyBtn.dataset.action;
            const itemEl = qtyBtn.closest('.cart-drawer__item');
            const qtyEl = itemEl.querySelector('.cart-drawer__qty-num');
            const current = parseInt(qtyEl.textContent, 10);
            const newQty = action === 'increase' ? current + 1 : Math.max(0, current - 1);
            await updateItem(key, newQty);
        }

        if (removeBtn) {
            await updateItem(removeBtn.dataset.key, 0);
        }
    });

    async function updateItem(key, qty) {
        loading.classList.add('active');
        try {
            const res = await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: key, quantity: qty }),
            });
            const cart = await res.json();
            renderItems(cart);
            updateHeaderCount(cart);
        } catch (err) {
            console.error('Cart update failed', err);
        } finally {
            loading.classList.remove('active');
        }
    }

    /* ── Update header cart count badge ── */
    function updateHeaderCount(cart) {
        const badges = document.querySelectorAll('[data-sb-cart-count]');
        const items = cart.items.filter(
            i => (i.product_type || '').toLowerCase() !== 'upsell'
        );
        const count = items.reduce((s, i) => s + i.quantity, 0);
        badges.forEach(b => { b.textContent = count; });
    }

    /* ── Auto-open after Add To Cart ── */
    document.addEventListener('click', async function (e) {
        const atcBtn = e.target.closest('[data-add-to-cart], .product-form__submit, [name="add"]');
        if (!atcBtn) return;

        const form = atcBtn.closest('form[action*="/cart/add"]') || atcBtn.closest('form');
        if (!form) return;

        e.preventDefault();
        loading.classList.add('active');

        try {
            const formData = new FormData(form);
            const res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Accept': 'application/json' },
                body: formData,
            });
            if (res.ok) {
                openDrawer();
            } else {
                form.submit();
            }
        } catch {
            form.submit();
        } finally {
            loading.classList.remove('active');
        }
    });

    /* ── Expose globally ── */
    window.SBCartDrawer = { open: openDrawer, close: closeDrawer, refresh: renderCart };
})();